import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/images/caac_windDir.png'
import _imports_1 from '@/assets/images/vk_zl_line.png'
import _imports_2 from '@/assets/images/dangerIcon.png'
import _imports_3 from '@/assets/images/fx_icon.png'
import _imports_4 from '@/assets/images/fs_wu.png'


const _hoisted_1 = { class: "flying-container" }
const _hoisted_2 = { class: "content-container" }
const _hoisted_3 = { class: "alarm-container" }
const _hoisted_4 = { class: "header-lf flex-row" }
const _hoisted_5 = { class: "header-rt flex-row" }
const _hoisted_6 = { class: "fps-container wind-dirct-container" }
const _hoisted_7 = { class: "fps-container" }
const _hoisted_8 = { class: "img-box" }
const _hoisted_9 = { class: "all-time" }
const _hoisted_10 = { class: "font-DIN" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "progress-box" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "wind-progess-container" }
const _hoisted_15 = { class: "progress-box" }
const _hoisted_16 = { class: "wind-info-conatainer" }
const _hoisted_17 = { class: "info-item" }
const _hoisted_18 = { class: "info-box" }
const _hoisted_19 = { class: "info-item" }
const _hoisted_20 = { class: "info-box" }
const _hoisted_21 = {
  key: 0,
  class: "fly-deviation-info-container"
}
const _hoisted_22 = { class: "deviation-header" }

import { ref } from 'vue'
import useFlying from './index'
import  useMouseHide from '@/hooks/useMouseHide'
import flyBasicInfo from '@/components/modules/flight/flyInfo/flyBasicInfo.vue'
import flyDeviationInfo from '@/components/modules/flight/flyInfo/flyDeviationInfo.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    // 定义组件的属性
},
  emits: {
    // 定义组件的事件
},
  setup(__props, { emit: __emit }) {

const timeBoxRef = ref<HTMLDivElement | null>(null);
const timeBox = ref<HTMLDivElement | null>(null);
const progressRef = ref<HTMLDivElement | null>(null);
const countdownRef = ref<HTMLDivElement | null>(null);
const flyCanvasRef = ref<HTMLDivElement | null>(null);
const gradCanvasRef = ref<HTMLDivElement | null>(null);
const errorCountdownRef = ref<HTMLDivElement | null>(null);
const flyDeviationInfoRef = ref<any>(null);
const { isMouseHidden } = useMouseHide(3000)
const props = __props

const emits = __emit

const {
    sceneImage,
    receive,
    sum,
    speed,
  currentFile,
  maxFile,
    uavStatusList,
    connectIcon,
    currentTime,
    isShowAlarm,
    currentPage,
    handleRestart,
    currentStepIndex,
    altitude,
    horizonalSpeed,
    courseAngle,
    angularSpeed,
    flyingInfo,
    totalSeconds,
    $enum,
    lockStatus,
    lockIcon,
    handleBack,
    handleBackCallback,
    currentSeconds,
    handleLock,
    onGround,
    engineInitialized,
    gradTotalTime,
    pageVisible,
    loading3D,
    loadingProgess,
    currentTask,
    currentWindDirection,
    currentWindSpeed,
    allPassTime,
    fpsStatus,
    showElectronic,
    connectStatus,
    isReady,
    collisionAlarm,
    currentWind,
    realTimeAngleOffset,
    aiCoachSettlementData,
    handleOpenSettingFullscreen,
    handleOpenPDF,
    flyDeviationViewMode,
    forbidAiCoach
} = useFlying(props, emits, timeBoxRef,timeBox,progressRef,countdownRef,flyCanvasRef,gradCanvasRef,errorCountdownRef,flyDeviationInfoRef);

return (_ctx: any,_cache: any) => {
  const _component_vkm_loading3D = _resolveComponent("vkm-loading3D")!
  const _component_vkm_svg = _resolveComponent("vkm-svg")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_vkm_remoteStatus = _resolveComponent("vkm-remoteStatus")!
  const _component_vkn_button = _resolveComponent("vkn-button")!
  const _component_vkm_passGrade = _resolveComponent("vkm-passGrade")!
  const _component_vkm_uavCrash = _resolveComponent("vkm-uavCrash")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(currentPage) == 1)
      ? (_openBlock(), _createBlock(_component_vkm_loading3D, {
          key: 0,
          engineInitialized: _unref(engineInitialized),
          sceneImage: _unref(sceneImage),
          receive: _unref(receive),
          sum: _unref(sum),
          speed: _unref(speed),
          currentFile: _unref(currentFile),
          maxFile: _unref(maxFile),
          progressValue: _unref(loadingProgess),
          title: _unref(loading3D).title,
          description: _unref(loading3D).description,
          pageType: _unref(loading3D).pageType
        }, null, 8, ["engineInitialized", "sceneImage", "receive", "sum", "speed", "currentFile", "maxFile", "progressValue", "title", "description", "pageType"]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", _hoisted_3, null, 512), [
        [_vShow, _unref(collisionAlarm) || _unref(isShowAlarm)]
      ]),
      _createElementVNode("div", {
        class: "caac-header flex-row",
        style: _normalizeStyle({ cursor: _unref(isMouseHidden) ? 'none !important' : 'default !important' })
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("i", {
            class: "iconfont-line vk_prevleft_line",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(handleBackCallback)('icon'))),
            style: _normalizeStyle({ cursor: _unref(isMouseHidden) ? 'none !important' : 'pointer !important' })
          }, null, 4),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(uavStatusList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(index <= _unref(currentStepIndex)?'uav-status-item active-status':'uav-status-item'),
              key: index
            }, [
              _createElementVNode("span", null, _toDisplayString(item), 1),
              (index != _unref(uavStatusList)?.length - 1)
                ? (_openBlock(), _createBlock(_component_vkm_svg, {
                    key: 0,
                    "icon-name": index < _unref(currentStepIndex)?'current_step':'uncurrent_step' ,
                    class: "icon"
                  }, null, 8, ["icon-name"]))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "img-box" }, [
              _createElementVNode("img", {
                class: "vk_zl_line",
                src: _imports_0,
                alt: ""
              })
            ], -1)),
            _createElementVNode("p", null, _toDisplayString(_unref(currentWind)) + "m/s", 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[6] || (_cache[6] = _createElementVNode("img", {
                class: "vk_zl_line",
                src: _imports_1,
                alt: ""
              }, null, -1)),
              (_unref(fpsStatus) < 30)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "denger-icon",
                    src: _imports_2,
                    alt: "",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(handleOpenPDF) && _unref(handleOpenPDF)(...args)))
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("p", null, [
              _cache[7] || (_cache[7] = _createTextVNode("FPS:")),
              _createElementVNode("span", {
                class: _normalizeClass({'danger':_unref(fpsStatus) < 30})
              }, _toDisplayString(_unref(fpsStatus)), 3)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_vkm_svg, {
              "icon-name": "all_time",
              class: "icon"
            }),
            _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(gradTotalTime)), 1)
          ]),
          _createElementVNode("img", {
            class: "connect-icon",
            src: _unref(connectIcon),
            alt: "",
            style: _normalizeStyle({ cursor: _unref(isMouseHidden) ? 'none !important' : 'pointer !important' })
          }, null, 12, _hoisted_11),
          _createVNode(_component_el_tooltip, {
            class: "box-item",
            effect: "dark",
            content: "设置",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createElementVNode("i", {
                class: "iconfont-fill vk_sz_fill header-icon",
                style: _normalizeStyle({ cursor: _unref(isMouseHidden) ? 'none !important' : !_unref(isReady) ? 'not-allowed !important' : 'pointer !important' }),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(handleOpenSettingFullscreen)(_unref(isReady))))
              }, null, 4)
            ]),
            _: 1
          })
        ])
      ], 4),
      _createElementVNode("div", {
        class: "countdown-container",
        style: _normalizeStyle({ cursor: _unref(isMouseHidden) ? 'none !important' : 'default !important' })
      }, [
        _createElementVNode("div", {
          ref_key: "timeBoxRef",
          ref: timeBoxRef,
          class: "progress-content"
        }, [
          (_unref(totalSeconds) != -1)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(_unref(currentSeconds) >= 1 && _unref(totalSeconds) - _unref(currentSeconds) >= 1 && _unref(pageVisible)?'animation-time time-container':'time-container'),
                ref_key: "timeBox",
                ref: timeBox
              }, [
                _createElementVNode("span", null, _toDisplayString(_unref(currentTime)), 1)
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_12, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "dv3" }, null, -1)),
            (_unref(totalSeconds) != -1)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(_unref(currentSeconds) >= 1 && _unref(totalSeconds) - _unref(currentSeconds) >= 1 && _unref(pageVisible)?'animation-dv4 dv4':'dv4'),
                  ref_key: "progressRef",
                  ref: progressRef
                }, null, 2))
              : _createCommentVNode("", true)
          ])
        ], 512)
      ], 4),
      _createElementVNode("div", {
        class: _normalizeClass(_unref(lockStatus) == _unref($enum).SWITCH_STATUS.ON && !_unref(onGround)?'none-click-btn lock-container':'lock-container' ),
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(handleLock) && _unref(handleLock)(...args)))
      }, [
        _createElementVNode("img", {
          src: _unref(lockIcon),
          alt: "",
          style: _normalizeStyle({ cursor: _unref(isMouseHidden) ? 'none !important' : 'pointer !important' })
        }, null, 12, _hoisted_13)
      ], 2),
      _createVNode(_component_vkm_remoteStatus, {
        isRemoteConnected: !!_unref(connectStatus),
        isReady: _unref(isReady)
      }, null, 8, ["isRemoteConnected", "isReady"]),
      _createElementVNode("div", {
        class: "wind-container",
        style: _normalizeStyle({ cursor: _unref(isMouseHidden) ? 'none !important' : 'default !important' })
      }, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("p", null, [
            _cache[9] || (_cache[9] = _createElementVNode("span", null, "任务进度", -1)),
            _createElementVNode("span", null, _toDisplayString(_unref(currentTask)) + "/3", 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1,2,3], (item) => {
              return _createElementVNode("div", {
                class: _normalizeClass(_unref(currentTask) >= item?'current-task':''),
                key: item
              }, null, 2)
            }), 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "icon-box" }, [
              _createElementVNode("img", {
                src: _imports_3,
                alt: ""
              })
            ], -1)),
            _createElementVNode("div", _hoisted_18, [
              _cache[10] || (_cache[10] = _createElementVNode("span", { class: "title" }, "风向", -1)),
              _createElementVNode("p", null, _toDisplayString(_unref(currentWindDirection)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "icon-box" }, [
              _createElementVNode("img", {
                src: _imports_4,
                alt: ""
              })
            ], -1)),
            _createElementVNode("div", _hoisted_20, [
              _cache[13] || (_cache[13] = _createElementVNode("span", { class: "title" }, "最大风速", -1)),
              _createElementVNode("p", null, [
                _createTextVNode(_toDisplayString(_unref(currentWindSpeed)), 1),
                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "unit" }, "m/s", -1))
              ])
            ])
          ])
        ])
      ], 4),
      _createVNode(flyBasicInfo, {
        altitude: _unref(altitude),
        horizonalSpeed: _unref(horizonalSpeed),
        courseAngle: _unref(courseAngle),
        realTimeAngleOffset: _unref(realTimeAngleOffset),
        angularSpeed: _unref(angularSpeed),
        isMouseHidden: _unref(isMouseHidden)
      }, null, 8, ["altitude", "horizonalSpeed", "courseAngle", "realTimeAngleOffset", "angularSpeed", "isMouseHidden"]),
      (_unref(isReady))
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _cache[16] || (_cache[16] = _createElementVNode("span", { class: "header-title" }, "飞行数据", -1)),
              (_unref(forbidAiCoach) == 1)
                ? (_openBlock(), _createBlock(_component_vkn_button, {
                    key: 0,
                    class: "insert-btn",
                    label: _unref(flyDeviationViewMode) === _unref($enum).FlyDeviationViewMode.卡片 ? '曲线' : '卡片' ,
                    type: "tertiary",
                    size: "medium",
                    onClick: _cache[4] || (_cache[4] = ()=>{flyDeviationViewMode.value = _unref(flyDeviationViewMode) === _unref($enum).FlyDeviationViewMode.卡片 ? _unref($enum).FlyDeviationViewMode.曲线 : _unref($enum).FlyDeviationViewMode.卡片;})
                  }, {
                    icon: _withCtx(() => _cache[15] || (_cache[15] = [
                      _createElementVNode("i", { class: "iconfont-line vk_qh_line" }, null, -1)
                    ])),
                    _: 1
                  }, 8, ["label"]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(flyDeviationInfo, {
              ref_key: "flyDeviationInfoRef",
              ref: flyDeviationInfoRef,
              isMouseHidden: _unref(isMouseHidden),
              isReady: _unref(isReady),
              flyingInfo: _unref(flyingInfo),
              viewMode: _unref(flyDeviationViewMode)
            }, null, 8, ["isMouseHidden", "isReady", "flyingInfo", "viewMode"])
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", {
        class: "uav-actions-container",
        style: _normalizeStyle({ cursor: _unref(isMouseHidden) ? 'none !important' : 'default !important' })
      }, [
        _createElementVNode("div", {
          class: "canvas-container electronic-pile-container info-btn",
          ref_key: "flyCanvasRef",
          ref: flyCanvasRef
        }, null, 512)
      ], 4), [
        [_vShow, _unref(showElectronic)]
      ])
    ], 512), [
      [_vShow, _unref(currentPage) == 2]
    ]),
    (_unref(currentPage) == 3)
      ? (_openBlock(), _createBlock(_component_vkm_passGrade, {
          key: 1,
          allPassTime: _unref(allPassTime),
          onOnBack: _unref(handleBackCallback),
          onOnRestart: _unref(handleRestart)
        }, null, 8, ["allPassTime", "onOnBack", "onOnRestart"]))
      : _createCommentVNode("", true),
    (_unref(currentPage) == 4)
      ? (_openBlock(), _createBlock(_component_vkm_uavCrash, { key: 2 }))
      : _createCommentVNode("", true)
  ]))
}
}

})